(function () {
    'use strict';

    // @ngInject
    Services.recurly = function recurly($window, UsersManager, $q, ThirdPartyLoaderService) {
        ThirdPartyLoaderService.loadCss('https://js.recurly.com/v4/recurly.css');
        return ThirdPartyLoaderService.loadUrlPromise('https://js.recurly.com/v4/recurly.js', function() {return $window.recurly;})
            .then(function(recurlySdk) {
                recurlySdk.configure(UsersManager.getCurrUser().recurly_key);
                return $q.resolve(recurlySdk);
            });
    };

}());